/**
 * DLT Industrial B2B Theme Master JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {
  initPredictiveSearch();
  initMobileMenu();
});

/* Predictive Search Engine */
function initPredictiveSearch() {
  const searchInput = document.querySelector('[data-predictive-search-input]');
  const searchResultsContainer = document.querySelector('[data-predictive-search-results]');

  if (!searchInput || !searchResultsContainer) return;

  let debounceTimer;

  searchInput.addEventListener('input', (e) => {
    clearTimeout(debounceTimer);
    const query = e.target.value.trim();

    if (query.length < 2) {
      searchResultsContainer.innerHTML = '';
      searchResultsContainer.style.display = 'none';
      return;
    }

    debounceTimer = setTimeout(() => {
      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          searchResultsContainer.innerHTML = resultsMarkup;
          searchResultsContainer.style.display = 'block';
        })
        .catch((error) => console.error('Predictive Search Error:', error));
    }, 300);
  });
}

/* Mobile Navigation Toggle */
function initMobileMenu() {
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const navMenu = document.querySelector('[data-nav-menu]');

  if (menuToggle && navMenu) {
    menuToggle.addEventListener('click', () => {
      navMenu.classList.toggle('is-active');
    });
  }
}